import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "aiAgentV2" */
      /* webpackPrefetch: true */
      './AIAgent'
    ),
);
